export const TranslateNotifType = (type: string) => {
    switch (type) {
        case 'temperature_requirement':
            return 'پیش آگاهی نیاز دمایی';
        case 'developmental_stage':
            return 'پیش آگاهی مراحل رشدی';
        case 'decision_support_system':
            return 'سیستم پشتیبان تصمیم';
        case 'account':
            return 'پیش آگاهی حساب کاربری';
        case 'activity':
            return 'مدیریت فعالیت های مزرعه';
        case 'cultivation_management':
            return 'یادآوری ثبت کشت';
        case 'discounts':
            return 'ارائه تخفیف به مشتریان';
        case 'farm_management':
            return 'مدیریت تعارضات و محدودیت های ثبت';
        case 'fertilizer_recommendation':
            return 'توصیه کودی';
        case 'general':
            return 'اطلاع رسانی و رویدادها';
        case 'hojre':
            return 'مدیریت حجره مزرعه';
        case 'monitoring':
            return 'پایش ماهوارهای';
        case 'pest':
            return 'پیش آگاهی آفات';
        case 'points':
            return 'ارائه مشوق به مشتریان';
        case 'staff':
            return 'مدیریت کارکنان مزرعه';
        case 'store':
            return 'مدیریت فروشگاه مزرعه';
        case 'warehouse':
            return 'مدیریت موجودی انبار و تعمیرات دوره';
        case 'water_requirement':
            return 'برنامه آبیاری';
        case 'weather':
            return 'پیش آگاهی هواشناسی';
        default:
            return 'پیش آگاهی هواشناسی';
    }
};
